export const trimFormValue = (value: string | null | undefined): string => {
  return value?.trim() ?? "";
};

export const trimFormValueOptional = (
  value: string | undefined
): string | undefined => {
  return value?.trim();
};
